module.exports = __webpack_public_path__ + "bo.svg?b42109acd165709aee8fb96d752f6480";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/bo.svg
// module id = 762
// module chunks = 27